<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="900px">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="功能名称" prop="name">
            <el-input v-model="dataForm.name" placeholder="请输入功能名称" maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="图标" prop="icon">
            <el-input v-model="dataForm.icon" placeholder="请输入Emoji图标" maxlength="10">
              <template slot="append">
                <el-button @click="showIconPicker = !showIconPicker">选择</el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 图标选择器 -->
      <el-form-item v-if="showIconPicker" label="常用图标">
        <div style="border: 1px solid #ddd; border-radius: 4px; padding: 15px; max-height: 200px; overflow-y: auto;">
          <span v-for="emoji in emojiList" :key="emoji" 
                @click="selectEmoji(emoji)" 
                style="font-size: 32px; margin: 8px; cursor: pointer; display: inline-block; transition: transform 0.2s;"
                @mouseover="$event.target.style.transform='scale(1.3)'"
                @mouseout="$event.target.style.transform='scale(1)'">
            {{ emoji }}
          </span>
        </div>
      </el-form-item>
      
      <el-form-item label="链接类型" prop="linkType">
        <el-radio-group v-model="dataForm.linkType">
          <el-radio label="inner">内部页面</el-radio>
          <el-radio label="outer">外部链接</el-radio>
          <el-radio label="miniapp">跳转小程序</el-radio>
          <el-radio label="channels">跳转视频号</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <!-- 内部页面/外部链接配置 -->
      <el-form-item v-if="dataForm.linkType !== 'miniapp' && dataForm.linkType !== 'channels'" label="跳转链接" prop="linkUrl">
        <el-input v-model="dataForm.linkUrl" placeholder="例如：/pages/article/list 或 https://www.example.com" type="textarea" :rows="2"></el-input>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">
          内部页面示例：/pages/article/list、/pages/yuangong/center<br>
          外部链接示例：https://www.example.com
        </div>
      </el-form-item>
      
      <!-- 提示：选择小程序或视频号时不需要填写跳转链接 -->
      <el-alert 
        v-if="dataForm.linkType === 'miniapp' || dataForm.linkType === 'channels'"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 15px;">
        <template slot="title">
          <span v-if="dataForm.linkType === 'miniapp'">✅ 已选择"跳转小程序"，无需填写"跳转链接"字段</span>
          <span v-if="dataForm.linkType === 'channels'">✅ 已选择"跳转视频号"，无需填写"跳转链接"字段</span>
        </template>
      </el-alert>
      
      <!-- 小程序配置 -->
      <div v-if="dataForm.linkType === 'miniapp'">
        <el-alert
          title="重要提示：使用小程序跳转功能前，请先在微信公众平台配置关联"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 15px;">
          <template slot>
            <div style="line-height: 1.8; font-size: 13px;">
              <p><strong>【第一步】在微信公众平台添加关联：</strong></p>
              <p style="margin-left: 15px;">
                1. 登录 <a href="https://mp.weixin.qq.com" target="_blank">https://mp.weixin.qq.com</a><br>
                2. 设置 → 第三方设置 → 小程序跳转<br>
                3. 点击"添加"，输入下面的AppID
              </p>
              <p><strong>【第二步】等待对方小程序管理员确认</strong></p>
              <p style="margin-left: 15px;">
                对方需要登录公众平台同意关联，可能需要您联系对方管理员
              </p>
              <p><strong>【第三步】确认关联成功后再配置此菜单</strong></p>
              <p style="margin-left: 15px; color: #67C23A;">
                💡 提示：如果是同一主体的小程序，无需对方确认
              </p>
            </div>
          </template>
        </el-alert>
        
        <el-form-item label="小程序AppID" prop="miniAppId">
          <el-input v-model="dataForm.miniAppId" placeholder="请输入目标小程序的AppID，例如：wx1234567890abcdef" maxlength="50"></el-input>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            * 必填，格式：wx开头的16-18位字符
          </div>
        </el-form-item>
        
        <el-form-item label="目标页面路径" prop="miniAppPath">
          <el-input v-model="dataForm.miniAppPath" placeholder="可选，例如：pages/index/index" maxlength="200"></el-input>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            可选，不填则跳转到对方小程序首页。示例：pages/index/index
          </div>
        </el-form-item>
      </div>
      
      <!-- 视频号配置 -->
      <div v-if="dataForm.linkType === 'channels'">
        <el-alert
          title="✅ 好消息：视频号跳转功能已简化，无需关联即可跳转到任意视频号！"
          type="success"
          :closable="false"
          show-icon
          style="margin-bottom: 15px;">
          <template slot>
            <div style="line-height: 1.8; font-size: 13px;">
              <p><strong>📱 功能说明（基于微信基础库 2.19.2+）：</strong></p>
              <p style="margin-left: 15px; color: #67C23A;">
                ✨ <strong>无主体限制</strong>：小程序可以直接跳转到任意视频号，无需关联！<br>
                📺 <strong>跳转方式</strong>：使用 wx.openChannelsActivity 接口<br>
                🔗 <strong>支持范围</strong>：可跳转到任意视频号的主页或指定视频
              </p>
              <p><strong>【第一步】获取视频号ID（必需）：</strong></p>
              <p style="margin-left: 15px;">
                1. 登录视频号助手 <a href="https://channels.weixin.qq.com" target="_blank">https://channels.weixin.qq.com</a><br>
                2. 点击首页查看自己的<strong>视频号ID</strong><br>
                3. 视频号ID格式：<code style="color: #E6A23C;">sph</code> 开头的字符串
              </p>
              <p><strong>【第二步】获取视频ID（可选）：</strong></p>
              <p style="margin-left: 15px;">
                如果要跳转到指定视频，需要获取视频的 feedId：<br>
                1. 登录视频号助手<br>
                2. 动态管理 → 找到目标视频 → 复制 feedId<br>
                3. feedId 示例：<code style="color: #E6A23C;">export/UzFfAgtgekIEAQAA...</code>
              </p>
              <p style="margin-left: 15px; color: #909399; font-size: 12px;">
                💡 <strong>提示</strong>：<br>
                • 只填写视频号ID：跳转到视频号主页<br>
                • 同时填写视频号ID和视频ID：跳转到指定视频
              </p>
              <p style="margin-left: 15px; color: #F56C6C; font-size: 12px;">
                ⚠️ <strong>注意</strong>：此功能仅在微信小程序环境下生效，H5环境不支持
              </p>
            </div>
          </template>
        </el-alert>
        
        <el-form-item label="视频号ID" prop="channelsUserName">
            <el-input v-model="dataForm.channelsUserName" placeholder="请输入finderUserName，例如：sphxxxxx" maxlength="50">
            <template slot="prepend">finderUserName</template>
          </el-input>
          <div style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 10px; margin-top: 10px; font-size: 13px;">
            <div style="color: #856404; font-weight: bold; margin-bottom: 5px;">⚠️ 注意：这里填写的是 finderUserName（视频号ID），不是视频号名称！</div>
            <div style="color: #856404; line-height: 1.6;">
              <strong>正确获取方式：</strong><br>
              1️⃣ 登录视频号助手：<a href="https://channels.weixin.qq.com" target="_blank" style="color: #0066cc;">https://channels.weixin.qq.com</a><br>
              2️⃣ 点击<strong>首页</strong>，在页面中找到<strong>"视频号 ID"</strong><br>
              3️⃣ 复制该ID（格式：<code style="background: #f0f0f0; padding: 2px 6px; border-radius: 3px;">sph</code> 开头的字符串）<br><br>
              <strong style="color: #dc3545;">❌ 错误示例：</strong>填写视频号名称（如"张三的视频号"）<br>
              <strong style="color: #28a745;">✅ 正确示例：</strong>sphxxxxxxxxxxxxx（在视频号助手首页看到的ID）
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="视频/直播ID" prop="channelsFeedId">
          <el-input v-model="dataForm.channelsFeedId" placeholder="可选，留空则跳转到视频号主页" maxlength="100">
            <template slot="prepend">feedId</template>
          </el-input>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            <strong>可选参数：</strong><br>
            • 不填写：跳转到视频号主页<br>
            • 填写后：跳转到指定视频或直播<br><br>
            <strong>获取方式（在视频号助手中）：</strong><br>
            动态管理 → 找到目标视频 → 复制 feedId<br>
            格式示例：export/UzFfAgtgekIEAQAA...
          </div>
        </el-form-item>
      </div>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="分类" prop="category">
            <el-radio-group v-model="dataForm.category">
              <el-radio label="default">默认显示</el-radio>
              <el-radio label="expand">展开显示</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="背景颜色" prop="bgColor">
        <el-input v-model="dataForm.bgColor" placeholder="CSS背景样式">
          <template slot="prepend">预览</template>
          <template slot="append">
            <div :style="{background: dataForm.bgColor, width: '80px', height: '35px'}"></div>
          </template>
        </el-input>
        <div style="margin-top: 10px;">
          <span style="margin-right: 10px; color: #666;">常用渐变色：</span>
          <el-button size="mini" @click="dataForm.bgColor = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'" 
                     style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; border: none; margin: 2px;">
            紫色
          </el-button>
          <el-button size="mini" @click="dataForm.bgColor = 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'" 
                     style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: #fff; border: none; margin: 2px;">
            粉色
          </el-button>
          <el-button size="mini" @click="dataForm.bgColor = 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'" 
                     style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); color: #fff; border: none; margin: 2px;">
            蓝色
          </el-button>
          <el-button size="mini" @click="dataForm.bgColor = 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'" 
                     style="background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); color: #fff; border: none; margin: 2px;">
            绿色
          </el-button>
          <el-button size="mini" @click="dataForm.bgColor = 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'" 
                     style="background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); color: #fff; border: none; margin: 2px;">
            橙色
          </el-button>
          <el-button size="mini" @click="dataForm.bgColor = 'linear-gradient(135deg, #ffd89b 0%, #19547b 100%)'" 
                     style="background: linear-gradient(135deg, #ffd89b 0%, #19547b 100%); color: #fff; border: none; margin: 2px;">
            金色
          </el-button>
        </div>
      </el-form-item>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否启用" prop="isEnable">
            <el-switch
              v-model="dataForm.isEnable"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用">
            </el-switch>
            <div style="color: #ff9800; font-size: 12px; margin-top: 5px;">
              启用后将在小程序首页显示
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序" prop="sortOrder">
            <el-input-number v-model="dataForm.sortOrder" :min="0" :max="9999" controls-position="right"></el-input-number>
            <span style="margin-left: 10px; color: #999;">数字越小越靠前</span>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item label="功能描述" prop="description">
        <el-input v-model="dataForm.description" placeholder="可选，功能的详细描述" type="textarea" :rows="3" maxlength="500" show-word-limit></el-input>
      </el-form-item>
      
      <!-- 预览效果 -->
      <el-form-item label="预览效果">
        <div style="border: 1px dashed #ddd; padding: 20px; border-radius: 8px; background: #f9f9f9; text-align: center;">
          <div style="display: inline-block; text-align: center; width: 100px;">
            <div :style="{
              width: '80px',
              height: '80px',
              margin: '0 auto 10px',
              background: dataForm.bgColor || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '48px'
            }">
              {{ dataForm.icon || '📦' }}
            </div>
            <div style="font-size: 14px; color: #333;">{{ dataForm.name || '功能名称' }}</div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      showIconPicker: false,
      emojiList: [
        '🏢', '🎁', '👥', '📝', '💼', '📅', '📄', '🎓', '📊', '💰',
        '🏥', '🏦', '👤', '📋', '📰', '✅', '📢', '🎨', '🎬', '🔔',
        '🎉', '🎊', '✨', '⭐', '🌟', '💫', '🔥', '👋', '📌', '🎯',
        '💡', '⚡', '🚀', '🏆', '💬', '📞', '✉️', '🔗', '🏠', '🛒',
        '📱', '💻', '⌚', '📷', '🎵', '🎮', '🏃', '🚗', '✈️', '🌈'
      ],
      dataForm: {
        id: 0,
        name: '',
        icon: '',
        iconClass: '',
        linkUrl: '',
        linkType: 'inner',
        miniAppId: '',
        miniAppPath: '',
        channelsUserName: '',
        channelsFeedId: '',
        bgColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        category: 'default',
        isEnable: 1,
        sortOrder: 0,
        description: ''
      },
      dataRule: {
        name: [
          { required: true, message: '功能名称不能为空', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择分类', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: `/functionGrid/info/${this.dataForm.id}`,
            method: 'get'
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.dataForm.name = data.data.name
              this.dataForm.icon = data.data.icon
              this.dataForm.iconClass = data.data.iconClass
              this.dataForm.linkUrl = data.data.linkUrl
              this.dataForm.linkType = data.data.linkType
              this.dataForm.miniAppId = data.data.miniAppId
              this.dataForm.miniAppPath = data.data.miniAppPath
              this.dataForm.channelsUserName = data.data.channelsUserName
              this.dataForm.channelsFeedId = data.data.channelsFeedId
              this.dataForm.bgColor = data.data.bgColor
              this.dataForm.category = data.data.category
              this.dataForm.isEnable = data.data.isEnable
              this.dataForm.sortOrder = data.data.sortOrder
              this.dataForm.description = data.data.description
            }
          })
        }
      })
    },
    selectEmoji(emoji) {
      this.dataForm.icon = emoji
      this.showIconPicker = false
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 根据链接类型清理不需要的字段
          const submitData = { ...this.dataForm }
          
          if (submitData.linkType === 'miniapp') {
            // 跳转小程序时，清空linkUrl和视频号相关字段
            submitData.linkUrl = ''
            submitData.channelsUserName = ''
            submitData.channelsFeedId = ''
          } else if (submitData.linkType === 'channels') {
            // 跳转视频号时，清空linkUrl和小程序相关字段
            submitData.linkUrl = ''
            submitData.miniAppId = ''
            submitData.miniAppPath = ''
          } else if (submitData.linkType === 'inner' || submitData.linkType === 'outer') {
            // 内部页面或外部链接时，清空小程序和视频号相关字段
            submitData.miniAppId = ''
            submitData.miniAppPath = ''
            submitData.channelsUserName = ''
            submitData.channelsFeedId = ''
          }
          
          this.$http({
            url: `/functionGrid/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: submitData
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.el-button {
  margin: 2px;
}
</style>

